export default "__VITE_ASSET__Ch5ih11w__"